import { Marker } from "@vis.gl/react-google-maps";

/**
 * Custom Map Marker Component
 *
 * This component wraps the `Marker` component from `@vis.gl/react-google-maps`,
 * allowing additional props to be passed directly. It is designed for flexibility
 * in reusing `Marker` with custom configurations.
 *
 * @param {Object} rest - Props passed to the `Marker` component.
 * @param {Object} [rest.label] - The label for the marker.
 * @param {string} [rest.icon] - The icon for the marker.
 * @param {google.maps.LatLngLiteral | google.maps.LatLng} rest.position - The position of the marker.
 * @param {function} [rest.onMouseOver] - The event handler for the mouse over event on the marker.
 * @param {function} [rest.onMouseOut] - The event handler for the mouse leave event on the marker.
 * @returns {JSX.Element} A custom Google Maps Marker component.
 */
export function MiMarker(rest) {
  return <Marker {...rest} />;
}
